module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp13_4.719ef2e2.png";